import { Record } from 'immutable';

export default class ApiUserRecord extends Record({
  id: undefined,
  apiKey: undefined,
  createdAt: undefined,
  createdBy: undefined,
  description: undefined,
  enabled: undefined,
  lastUsedAt: undefined,
}) {
}
